export default __webpack_public_path__ + "static/media/small-green-pink-pattern.ad8efaf1.svg";